<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Schedule recurring notifications using cron expressions.</p>
        </div>
        <p-button label="Add Job" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>

    <div class="card">
        <p-table [value]="jobs()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="jobs().length > 10" [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Job</th>
                    <th>Channel</th>
                    <th>Schedule</th>
                    <th>Recipient</th>
                    <th>Active</th>
                    <th class="ta-r">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-j>
                <tr>
                    <td class="strong">{{ j.jobName }}</td>
                    <td>{{ channelLabel(j.channel) }}</td>
                    <td class="mono">{{ j.cronExpression }}</td>
                    <td class="muted ellipsis">{{ j.recipient }}</td>
                    <td>
                        <p-toggleSwitch [ngModel]="j.isActive" (onChange)="toggle(j)"
                            [pTooltip]="j.isActive ? 'Active — click to pause' : 'Paused — click to activate'" />
                    </td>
                    <td class="ta-r actions">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Edit" (onClick)="openEdit(j)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(j)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">
                        <div class="state"><i class="pi pi-clock"></i><p>No scheduled jobs yet.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [header]="editing() ? 'Edit Job' : 'Add Job'" styleClass="menu-dialog"
    [style]="{ width: '520px' }" [breakpoints]="{ '480px': '94vw' }">
    <form [formGroup]="form" class="menu-form">
        <div class="grid-2">
            <div class="field">
                <label>Job Name <span class="req">*</span></label>
                <input pInputText type="text" formControlName="jobName" placeholder="Daily reminder">
                @if (form.get('jobName')?.touched && form.get('jobName')?.invalid) {
                    <small class="err">Required</small>
                }
            </div>
            <div class="field">
                <label>Channel <span class="req">*</span></label>
                <p-select formControlName="channel" [options]="channels" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" placeholder="Select channel" appendTo="body" />
            </div>
        </div>

        <div class="field">
            <label>Cron Expression <span class="req">*</span></label>
            <input pInputText type="text" formControlName="cronExpression" placeholder="0 9 * * *">
            <div class="presets">
                @for (p of cronPresets; track p.value) {
                    <p-button [label]="p.label" [outlined]="true" size="small" styleClass="preset"
                        (onClick)="applyPreset(p.value)" />
                }
            </div>
            @if (form.get('cronExpression')?.touched && form.get('cronExpression')?.invalid) {
                <small class="err">Required</small>
            }
        </div>

        <div class="grid-2">
            <div class="field">
                <label>Recipient <span class="req">*</span></label>
                <input pInputText type="text" formControlName="recipient" placeholder="email / phone">
                @if (form.get('recipient')?.touched && form.get('recipient')?.invalid) {
                    <small class="err">Required</small>
                }
            </div>
            <div class="field">
                <label>Subject</label>
                <input pInputText type="text" formControlName="subject" placeholder="Optional">
            </div>
        </div>

        <div class="field">
            <label>Message <span class="req">*</span></label>
            <textarea pTextarea formControlName="body" rows="3" placeholder="Message body..."></textarea>
            @if (form.get('body')?.touched && form.get('body')?.invalid) {
                <small class="err">Required</small>
            }
        </div>

        <p-checkbox formControlName="isActive" [binary]="true" label="Active" />

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button label="Save" icon="pi pi-check" (onClick)="save()" [loading]="saving()" />
        </div>
    </form>
</p-dialog>
